import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { USER_PLAN_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

const SLICE = "Comments";

const isCommentsThunk = (action: any) => action.type.startsWith(`${SLICE}/`); // This is chech fullfilled and rejected cases only for Comments Slice.

const initialState: any = {
  loadingCount: 0,
  commentList: [],
  commentUsers: [],
  planMembers: []
};

export const createCommentAsync = createAsyncThunk(`${SLICE}/createCommentAsync`, (data: any, thunkApi) => {
  return apiRequest(USER_PLAN_SERVICE_METHOD.postComments, data, thunkApi);
});

export const fetchCommentAsync = createAsyncThunk(`${SLICE}/fetchCommentAsync`, (data: any, thunkApi) => {
  return apiRequest(USER_PLAN_SERVICE_METHOD.getComments, {}, thunkApi, [], data);
});

export const fetchCommentUsersAsync = createAsyncThunk(`${SLICE}/fetchCommentUsersAsync`, (data: any, thunkApi) => {
  const params = { size: data.size, hltIds: data.value };
  return apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], params);
});

export const fetchPlanMembersAsync = createAsyncThunk(`${SLICE}/fetchPlanMembersAsync`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getPlans, {}, thunkApi, [data.planId, "plan-members"])
);

export const Comments = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => {
      return {
        ...initialState
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCommentAsync.fulfilled, (state, action: any) => {
        state.commentList.unshift(...Object.values(action?.payload).filter((value) => value !== 200));
      })
      .addCase(fetchCommentAsync.fulfilled, (state, action: any) => {
        state.commentList = action.payload.commentList;
      })
      .addCase(fetchCommentUsersAsync.fulfilled, (state, action) => {
        state.commentUsers = [...action?.payload?.users, ...state.commentUsers];
      })
      .addCase(fetchPlanMembersAsync.fulfilled, (state, action) => {
        state.planMembers = action.payload?.planMembers;
      })
      .addMatcher(
        (action) => isPending(action) && isCommentsThunk(action),
        (state, action) => {
          if (
            // turn on loader if api is not paginated or it is for 1st page
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount += 1;
          }
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isCommentsThunk(action),
        (state, action) => {
          if (
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount -= 1;
          }
        }
      );
  }
});

export const { reset } = Comments.actions;

export default Comments.reducer;
